// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"Menu__menu--2iRwq","menu_item":"Menu__menu_item--1w_5e"};